import { Plugin } from 'rainbow-web-sdk/plugins/plugin';
import { BubbleConferenceServiceRB } from 'rainbow-web-sdk/services/conference/bubbleConference.service';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { BubbleConferenceRecapServiceRB } from '../services/conference/bubbleConferenceRecap.service';

export class BubbleConferencePlugin extends Plugin {
    public static initialize(): BubbleConferencePlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[BubbleConferencePlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[BubbleConferencePlugin] initialized");
            window.rainbow.plugins[BubbleConferencePlugin.name] = new BubbleConferencePlugin();
            BubbleConferenceServiceRB.getInstance();
            BubbleConferenceRecapServiceRB.getInstance();
        }
        return window.rainbow.plugins[BubbleConferencePlugin.name];
    }

    private constructor() {
        super();
    }
}
